import { render, staticRenderFns } from "./CardOther.vue?vue&type=template&id=0baa35e6&scoped=true"
import script from "./CardOther.vue?vue&type=script&lang=js"
export * from "./CardOther.vue?vue&type=script&lang=js"
import style0 from "./CardOther.vue?vue&type=style&index=0&id=0baa35e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa35e6",
  null
  
)

export default component.exports